import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer';
import Header from '../components/Header';
import '../assets/scss/termsAndConditions.scss';

function TermsAndConditions() {
  const { t } = useTranslation();

  return (
    <main>
      <Helmet>
        <title>Términos y Condiciones - Delmiro Mendez e Hijo S.A.</title>
        <meta name="description" content="Términos y condiciones de Delmiro Mendez e Hijo S.A." />
      </Helmet>
      <Header />
      <div className="terms-and-conditions-container">
        <div className="terms-and-conditions-content">
          <div className="terms-and-conditions-header">
            <h1>{t('terms-and-conditions.title')}</h1>
          </div>
          <div className="terms-section terms-intro-section">
            <p className="company-info">
              <strong>{t('terms-and-conditions.company')}</strong>
            </p>
            <p>{t('terms-and-conditions.legalAddress')}</p>
            <p>{t('terms-and-conditions.applicableLaw')}</p>
            <p>
              <a href={`mailto:${t('terms-and-conditions.contactEmail').split(': ')[1]}`}>
                {t('terms-and-conditions.contactEmail')}
              </a>
            </p>
            <p className="intro-text">
              {t('terms-and-conditions.intro')}
            </p>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section1.title')}</h2>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section1.subsection1.title')}</h3>
              <p>{t('terms-and-conditions.section1.subsection1.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section1.subsection2.title')}</h3>
              <p>{t('terms-and-conditions.section1.subsection2.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section1.subsection3.title')}</h3>
              <p>{t('terms-and-conditions.section1.subsection3.content')}</p>
            </div>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section2.title')}</h2>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section2.subsection1.title')}</h3>
              <p>{t('terms-and-conditions.section2.subsection1.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section2.subsection2.title')}</h3>
              <p>{t('terms-and-conditions.section2.subsection2.content')}</p>
            </div>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section3.title')}</h2>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section3.subsection1.title')}</h3>
              <p>{t('terms-and-conditions.section3.subsection1.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section3.subsection2.title')}</h3>
              <p>{t('terms-and-conditions.section3.subsection2.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section3.subsection3.title')}</h3>
              <p>{t('terms-and-conditions.section3.subsection3.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section3.subsection4.title')}</h3>
              <p>{t('terms-and-conditions.section3.subsection4.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section3.subsection5.title')}</h3>
              <p>{t('terms-and-conditions.section3.subsection5.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section3.subsection6.title')}</h3>
              <p>{t('terms-and-conditions.section3.subsection6.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section3.subsection7.title')}</h3>
              <p>{t('terms-and-conditions.section3.subsection7.content')}</p>
            </div>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section4.title')}</h2>
            <p>{t('terms-and-conditions.section4.content')}</p>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section5.title')}</h2>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section5.subsection1.title')}</h3>
              <p>{t('terms-and-conditions.section5.subsection1.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section5.subsection2.title')}</h3>
              <p>{t('terms-and-conditions.section5.subsection2.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section5.subsection3.title')}</h3>
              <p>{t('terms-and-conditions.section5.subsection3.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section5.subsection4.title')}</h3>
              <p>{t('terms-and-conditions.section5.subsection4.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section5.subsection5.title')}</h3>
              <p>{t('terms-and-conditions.section5.subsection5.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section5.subsection6.title')}</h3>
              <p>{t('terms-and-conditions.section5.subsection6.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section5.subsection7.title')}</h3>
              <p>{t('terms-and-conditions.section5.subsection7.content')}</p>
            </div>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section6.title')}</h2>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section6.subsection1.title')}</h3>
              <p>{t('terms-and-conditions.section6.subsection1.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section6.subsection2.title')}</h3>
              <p>{t('terms-and-conditions.section6.subsection2.content')}</p>
            </div>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section7.title')}</h2>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section7.subsection1.title')}</h3>
              <p>{t('terms-and-conditions.section7.subsection1.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section7.subsection2.title')}</h3>
              <p>{t('terms-and-conditions.section7.subsection2.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section7.subsection3.title')}</h3>
              <p>{t('terms-and-conditions.section7.subsection3.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section7.subsection5.title')}</h3>
              <p>{t('terms-and-conditions.section7.subsection5.content')}</p>
            </div>
          </div>

          <div className="terms-section">
            <h2>{t('terms-and-conditions.section8.title')}</h2>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section8.subsection1.title')}</h3>
              <p>{t('terms-and-conditions.section8.subsection1.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section8.subsection2.title')}</h3>
              <p>{t('terms-and-conditions.section8.subsection2.content')}</p>
            </div>
            <div className="subsection">
              <h3>{t('terms-and-conditions.section8.subsection3.title')}</h3>
              <p>{t('terms-and-conditions.section8.subsection3.content')}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default TermsAndConditions;
